import { ButtonThemes, SkeletonLoading } from '@app/shared';
import { useDataPreparationFastOrder } from '@entities/Product';
import { getIsLoaded, getListOrderFromStock, getListPickUpAllShops } from '@entities/Shop';
import { ButtonFastOrder, TypeTemplateFastOrder } from '@features/fastOrder';
import { useAppSelector } from '@redux/hooks';

import classNames from 'classnames';

import styles from './buttonFastOrderCardProduct.module.scss';

export const MobileButtonFastOrderCardProduct = ({ className, id }: { className?: string; id?: string }) => {
  const isLoaded = useAppSelector(getIsLoaded);
  const listShops = useAppSelector(getListPickUpAllShops);
  const IsOrderFromStock = useAppSelector(getListOrderFromStock);
  const product = useDataPreparationFastOrder();
  if (!isLoaded) {
    return <MobileButtonFastOrderCardProduct.Skeleton className={className} />;
  }

  if (isLoaded && listShops?.length) {
    return (
      <ButtonFastOrder
        id={id}
        className={classNames(styles.ButtonFastOrder, className)}
        themes={ButtonThemes.Secondary}
        template={TypeTemplateFastOrder.pickUpStore}
        productData={product}
        ecommerceLabel="Забрать в магазине"
        ecommerceScenario={'Сценарий 6'}
      >
        <div>
          <span>Забрать</span>
          <span>в магазине</span>
        </div>
      </ButtonFastOrder>
    );
  }

  if (isLoaded && !listShops?.length && IsOrderFromStock) {
    return (
      <ButtonFastOrder
        id={id}
        className={className}
        template={TypeTemplateFastOrder.orderOneClick}
        productData={product}
        ecommerceLabel="Быстрый заказ"
        ecommerceScenario={'Сценарий 7'}
      >
        Быстрый заказ
      </ButtonFastOrder>
    );
  }

  if (isLoaded && !listShops?.length && !IsOrderFromStock) {
    return null;
  }
};

MobileButtonFastOrderCardProduct.Skeleton = function Skeleton({ className }: { className?: string }) {
  return <SkeletonLoading className={className} width={'100%'} height={'40px'} />;
};
